import React, { Component } from 'react';
import { strings } from 'APP_ROOT/localization';

import LambdaUtil from '../../aws/lambda/lambdaUtil';
import Events from '../../common/events';

export default class CancelPlanSection extends Component {

    constructor(props) {

        super(props);
        this.state = {
            cancelErrorMessage: null,
            confirmCancel: false
        };
    }

    onCancelSubmit = (e) => {

        e.preventDefault();
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: "Cancelling Service Plan" } }));
        //todo cancel lambda
        LambdaUtil.cancelServicePlan(this.props.user.stage, this.props.subscription.subscriptionUuid, this.onCancelSuccess, this.onCancelFail)
    }

    onCancelSuccess = (data) => {

        console.log(data);
        var payload = JSON.parse(data.Payload);
        if (payload && payload.status && payload.status === "ERROR") {
            console.error(payload);
            this.setState({
                cancelErrorMessage: "An unknown error occured while trying to cancel your service plan. Please contact support to resolve this issue."
            }, () => { document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE)); });
            return;
        }

        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: "Successfully canceled your service plan", style: 'success', override: true } }));
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    }

    onCancelFail = (err) => {

        console.error(err);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.setState({
            cancelErrorMessage: "An unknown error occured while trying to cancel your service plan. Please contact support to resolve this issue."
        });
    }

    render() {

        var errorMessage = this.state.cancelErrorMessage ?
            <p className="error-message"><i className="material-icons">error_outline</i>{this.state.cancelErrorMessage}</p> : null;

        return (
            <div className="col-12 content-group">
                <form className="row" onSubmit={this.onCancelSubmit}>

                    <div className="col-12">
                        <h2><i className="material-icons">error_outline</i>{strings.account_cancel_service_plan_title}</h2>
                        <p>{strings.account_cancel_service_plan_description}</p>
                        <p>{strings.account_cancel_service_plan_confirmation}</p>
                    </div>

                    <div className="col-12 action-btns">
                        <button className="btn btn-outline-blue" onClick={this.props.goBack}><i className="material-icons">close</i>{strings.account_cancel_service_plan_cancel_action}</button>
                        <button className="btn btn-red"><i className="material-icons">check</i>{strings.account_cancel_service_plan_confirm_action}</button>
                        {errorMessage}
                    </div>

                </form>
            </div>
        );
    }
}
